<template>
  <v-card flat class="ms-8 me-12"  >
    <div class="title primary--text mx-3 pt-2">{{$t('Settings')}}</div>
    <v-form ref="form" @submit.prevent="submit">
      <v-container fluid class="pb-0">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.name"
              :rules="rules.name"
              :label="$t('Farm Name')"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-select
              v-model="form.valueScale"
              :items="valueScaleItems"
              :label="$t('Value By')"
              :hint="$t('Select units to use when calculating feeds and TMRs value')"
            ></v-select>
          </v-col>
          <v-col cols="5" sm="3" offset-sm-1>
            <v-combobox
              v-model="form.currency"
              :items="currencyList"
              :label="$t('Currency')"
              :hint="$t('Select the Preferred currency symbol to use for values')"
            ></v-combobox>
          </v-col>
          <v-col cols="5" sm="3" offset="2">
            <v-switch inset
              v-model="form.lightTheme"
              @change="themeChange"
              :label="$t('Light Theme') ">
            </v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-select
              v-model="form.language"
              :items="languageList"
              :label="$t('Language')"
              :hint="$t('Select the preferred language for the app')"
            ></v-select>
          </v-col>
          <v-col cols="4" sm="2" offset-1>
            <v-text-field
              v-model="form.separator"
              :label="$t('List Separator')"
              :hint="$t('Select the preferred charecter to use when exporting reports')"
              maxlength="1"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" offset-sm="2">
            <fileUploader :existingURL="form.logoURL" @downloadURL="getLogoUrl" class="mx-4 image-size"> </fileUploader>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="isAdminUser">
            <v-text-field
              v-model="assumeUser"
              label="Assume User"
              @change="assumeThisUser"
            ></v-text-field>
          </v-col>
        </v-row>


        <!-- <v-row>
          <v-col cols="12" class="py-0">
            <v-checkbox
              v-model="form.terms"
              color="green"
              class="ma-0"
            >
              <template v-slot:label>
                <div @click.stop="">
                  Do you accept the
                  <a href="javascript:;" @click.stop="terms = true">terms</a>
                  and
                  <a href="javascript:;" @click.stop="conditions = true">conditions?</a>
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row> -->

      </v-container>
      <v-card-actions class="pt-0 mt-n8">
        <v-spacer></v-spacer>

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn icon large color="primary" v-on="on" @click="resetForm">
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
          </template>
          <span>{{$t('Cancel') + " " + $t('exit without saving')}}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn icon x-large color="primary" v-on="on"
              class="ms-4"
              :disabled="!formIsValid"
              type="submit"
              @click="submit"
              >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <span>{{$t('Save Settings')}}</span>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
  import fileUploader from "../components/common/FileUploader"
  export default {
    name: "SettingsPage",
    components: {
      fileUploader
    },
    data () {
      return {
        form: {},
        rules: {
          name: [val => (val || "").length > 0 || this.$i18n.t('This field is required')],
        },
        valueScaleItems: [this.$i18n.t('Ton'), this.$i18n.t('Kilogram'), this.$i18n.t('Pound'), this.$i18n.t('US Ton')],
        conditions: false,
        terms: false,
        defaultForm: {},
        currencyList: [],
        usersList: [],
        languageList: ["English", "Hebrew"],
        currentLocale: 'en',
        darkTheme: true,
        assumeUser: ""

      }
    },
    created() {
      this.currencyList = this.$store.getters.getCurrencyList;
    },
    mounted() {
      this.defaultForm = this.$store.getters.getProfile;
      this.currentLocale = this.$i18n.locale;
      this.$nextTick(() => this.form = Object.assign({}, this.defaultForm) );
      this.darkTheme = this.$vuetify.theme.dark;
      //this.$store.dispatch("getUsersList").then( _list => this.usersList = _list);

    },
    computed: {
      formIsValid () {
        return (
          this.form.name &&
          this.form.terms
        )
      },
      isAdminUser() {
        return this.$store.getters.isAdminUser;
      }
    },
    watch: {
      defaultForm: function() {
        this.form = Object.assign({}, this.defaultForm);
      }
    },
    methods: {
      themeChange(val) {
        this.$vuetify.theme.dark = !val
      },
      getLogoUrl(value) {
        this.form.logoURL = value;
      },
      resetForm () {
        this.form = Object.assign({}, this.defaultForm);
        this.themeChange(this.darkTheme);
        this.$router.go(-1);
      },
      assumeThisUser(uid) {
        if (uid && uid.length > 8) {
          this.$store.dispatch("assumeUser", uid);
        }
      },
      submit () {
        const _locale = this.$store.getters.getLocaleFromLang(this.form.language);
        const _theme = this.form.lightTheme ? "light" : "dark";
        if (_locale){
          //save cookie with chosen locale and theme
          const cookieExpire = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
          document.cookie = "locale="+ _locale + "; expires=" + cookieExpire.toString();
          document.cookie =  "theme="+ _theme + "; expires=" + cookieExpire.toString();
        }
        this.$store.dispatch("saveProfile", this.form);

        if (_locale != this.currentLocale) {
          this.$root.$globalSnackbar(this.$t('Settings saved') + ", " + this.$t('changing language') + "...", "success");
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          this.$router.go(-1);
          this.$root.$globalSnackbar(this.$i18n.t('Settings saved'), "success");
        }
      },
    },
  }
</script>

<style>
  .image-size {
    width: 230px;
    height: 230px;

  }
</style>